<template>
    <div>
        <div v-if="productImageBeingViewed" class="muven-product-big-image-visualization">
            <div class="muven-product-big-image-backdrop"></div>

            <div class="muven-product-big-image-container">
                <div class="muven-product-big-image">
                    <img :src="productImageUrl" alt="Imagem" />

                    <fa icon="times" 
                        class="muven-product-big-image-close-icon" 
                        @click="closeProductImageVisualization()"/>
                </div>
            </div>
        </div>

        <div class="muven-column-layout">
            <div class="muven-column-left">
                <div class="muven-card mb-3">
                    <div class="muven-card-title">
                        <p>{{product.name}}</p>                        
                    </div>

                    <div class="row main-product-info-container">
                        <div class="col-12 mb-3">
                            <label>Descrição principal</label>
                            <p v-show="product.hasDescription()" v-html="product.getDescriptionWithLineBreaks()"></p>
                            <p v-show="!product.hasDescription()">-</p>
                        </div>

                        <div class="col-12 mb-3">
                            <label>Descrição curta</label>
                            <p v-show="product.hasDescriptionShort()" v-html="product.getDescriptionShortWithLineBreaks()"></p>
                            <p v-show="!product.hasDescriptionShort()">-</p>
                        </div>

                        <div class="col-12 mb-3">
                            <label>Descrição longa</label>
                            <p v-show="product.hasDescriptionLong()" v-html="product.getDescriptionLongWithLineBreaks()"></p>
                            <p v-show="!product.hasDescriptionLong()">-</p>
                        </div>
                    </div>
                </div>

                <div class="muven-card mb-3">
                    <div class="muven-card-title">
                        <p>Categorias</p>
                    </div>

                    <div class="">
                        <div>
                            <label>Nome</label>
                        </div>

                        <div v-for="(productCategoryChannel, index) in product.getCategories()" :key="index">
                            <p class="mb-3">{{productCategoryChannel.category.name | infoOrPlaceholder}}</p>
                        </div>

                        <div v-if="!product.hasCategories()">
                            <p>-</p>
                        </div>                            
                    </div>
                </div>

                <div class="muven-card mb-3">
                    <div class="muven-card-title">
                        <p>Marca</p>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <label>Nome</label>
                            <p>{{product.getBrand().name | infoOrPlaceholder}}</p>
                        </div>
                    </div>
                </div>

                <div class="muven-card mb-3">
                    <div class="muven-card-title">
                        <p>SEO</p>
                    </div>

                    <div class="row">
                        <div class="col-12 mb-3">
                            <label>Título</label>
                            <p>{{product.seoTitle | infoOrPlaceholder}}</p>
                        </div>

                        <div class="col-12 mb-3">
                            <label>Descrição</label>
                            <p>{{product.seoDescription | infoOrPlaceholder}}</p>
                        </div>

                        <div class="col-12">
                            <label>Palavras chave</label>
                            <p>{{product.seoKeywords | infoOrPlaceholder}}</p>
                        </div>
                    </div>
                </div>

                <div class="muven-card mb-3">
                    <div class="muven-card-title">
                        <p>Vídeo</p>
                    </div>

                    <div>
                        <label>URL do vídeo</label>
                        <p>{{product.videoUrl | infoOrPlaceholder}}</p>
                    </div>
                </div>                
            </div>
            
            <div class="muven-column-right">
                <div class="muven-card mb-3">
                    <div class="muven-card-title">
                        <p>Status</p>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <p>
                                <span v-if="product.isActive">Ativo</span>
                                <span v-if="!product.isActive">Inativo</span>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="muven-card mb-3">
                    <div class="muven-card-title">
                        <p>Integração retaguarda</p>
                    </div>

                    <div>
                        <div class="mb-3">
                            <label>Id na retaguarda</label>
                            <p>{{product.idSource | infoOrPlaceholder}}</p>
                        </div>                          

                        <div class="mb-3">
                            <label>Código na retaguarda</label>
                            <p>{{product.codeSource | infoOrPlaceholder}}</p>
                        </div>                      

                        <div class="mb-3">
                            <label>Importação da retaguarda</label>
                            <p>{{product.getAllowImportDescription() | infoOrPlaceholder}}</p>
                        </div>    

                        <div class="mb-3">
                            <label>Dias para entrega</label>
                            <p>{{product.additionalDeliveryDays | infoOrPlaceholder}}</p>
                        </div>                          

                        <div>
                            <label>Atualização</label>
                            <p>{{product.updatedAt | dateTimeFilter | infoOrPlaceholder}}</p>
                        </div>
                    </div>
                </div>

                <div class="muven-card mb-3" v-for="(storeChannel, index) in product.getUniqueStoreChannels()" :key="index"
                    v-show="product.hasStores()">
                    <div class="muven-card-title">
                        <p>Integração {{storeChannel.channel.name}}</p>
                    </div>

                    <div>
                        <div class="row">
                            <div class="col-12 mb-3">
                                <label>Id do produto pai no canal</label>
                                <p>{{storeChannel.idExternalChannel | infoOrPlaceholder}}</p>
                            </div>

                            <div class="col-12 mb-3">
                                <label>Preços (listagem / venda)</label>
                                <p>{{storeChannel.listPrice | currency}} / {{storeChannel.sellPrice | currency}}</p>
                            </div>

                            <div class="col-12">
                                <label>Status do produto pai no canal</label>
                                <p>
                                    <span v-show="storeChannel.isActive">Ativo</span>
                                    <span v-show="!storeChannel.isActive">Inativo</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="muven-card mb-3" v-if="!product.isVirtual">
                    <div class="muven-card-title">
                        <p>Cubagem</p>
                    </div>

                    <div class="row mb-3">
                        <div class="col-12 col-md-6">
                            <label>Peso</label>
                            <p>{{product.weight | infoOrPlaceholder}} kg</p>
                        </div>
                        <div class="col-12 col-md-6">
                            <label>Altura</label>
                            <p>{{product.height | infoOrPlaceholder}} cm</p>
                        </div>
                    </div>                        

                    <div class="row">
                        <div class="col-12 col-md-6">
                            <label>Largura</label>
                            <p>{{product.width | infoOrPlaceholder}} cm</p>
                        </div>
                        <div class="col-12 col-md-6">
                            <label>Profundidade</label>
                            <p>{{product.depth | infoOrPlaceholder}} cm</p>
                        </div>

                    </div>
                </div>
            </div>

            <div class="muven-column-full">
                <div class="muven-card mb-3">
                    <div class="muven-card-title">
                        <p>Imagens</p>
                    </div>

                    <div class="product-image-container">
                        <div v-if="!product.hasImages()">
                            <p>-</p>
                        </div>

                        <div class="text-center row justify-content-center" v-if="product.hasImages()">
                            <div class="col" v-for="(img, index) in product.getImages()" :key="index">
                                <img :class="{
                                        'product-image-main': img.isMain,
                                        'product-image-inactive': !img.isActive,
                                    }"
                                    :src="img.url" 
                                    alt="Imagem"
                                    @click="viewProductImage($event)">
                                <p class="product-image-dimensions">
                                    <span>{{img.getSizeInformation()}}</span>
                                </p>
                                <p class="product-image-description"
                                    :class="{
                                        'image-main': img.isMain && img.isActive,
                                        'image-inactive': !img.isActive,
                                    }"> 
                                    <span v-if="img.isMain && img.isActive">Principal</span>                                        
                                    <span v-if="!img.isActive">Inativa</span>                                        
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="muven-card mb-3">
                    <div class="muven-card-title">
                        <p>Variações</p>
                    </div>

                    <div class="product-variation-list-card">
                        <div class="product-variation-item" v-for="(gridRow, index) in productVariations" :key="index">
                            <div class="row product-variation-main-info">
                                <div class="col mb-3">
                                    <label>{{bidimensionalGrid.getFirstName()}}</label>
                                    <p>{{gridRow.firstVariation}}</p>
                                </div>

                                <div class="col mb-3" v-show="!!bidimensionalGrid.getSecondName()">
                                    <label>{{bidimensionalGrid.getSecondName()}}</label>
                                    <p>{{gridRow.secondVariation}}</p>
                                </div>

                                <div class="col mb-3">
                                    <label>Sku</label>
                                    <p>{{gridRow.skuCode}}</p>
                                </div>

                                <div class="col mb-3">
                                    <label>Código retaguarda</label>
                                    <p>{{gridRow.codeSource | infoOrPlaceholder}}</p>
                                </div>

                                <div class="col mb-3">
                                    <label>Estoque somado</label>
                                    <p>{{gridRow.stockQty}}</p>
                                </div>

                                <div class="col mb-3">
                                    <label>Status</label>
                                    <p>
                                        <span v-show="gridRow.isActive">Ativo</span>
                                        <span v-show="!gridRow.isActive">Inativo</span>
                                    </p>
                                </div>

                                <div class="variation-visibility-toggle-container" @click="toggleVariationCollapse(gridRow)">
                                    <fa icon="chevron-down" 
                                        class="variation-toggle-icon" 
                                        :class="{'variation-toggle-icon-flipped': !gridRow.collapsed}" />
                                </div>
                            </div>

                            <div class="product-variation-more-info" :class="{'variation-visible': !gridRow.collapsed}">
                                <div v-if="gridRow.stores.length === 0">
                                    <div class="row">
                                        <div class="col-6 col-md-3 mb-3">
                                            <label>Estoque</label>
                                            <p>Desconhecido</p>
                                        </div>

                                        <div class="col-6 col-md-3 mb-3">
                                            <label>Estoque reservado</label>
                                            <p>Desconhecido</p>
                                        </div>        

                                        <div class="col-6 col-md-3 mb-3">
                                            <label>Estoque disponível</label>
                                            <p>Desconhecido</p>
                                        </div>       

                                        <div class="col-6 col-md-3 mb-3">
                                            <label>Fator de conversão</label>
                                            <p>Desconhecido</p>
                                        </div>       
                                    </div>
                                </div>

                                <div v-if="gridRow.stores.length === 1">
                                    <div class="row">
                                        <div class="col-6 col-md-3 mb-3">
                                            <label>Estoque</label>
                                            <p>{{gridRow.stores[0].stockQty | infoOrPlaceholder}}</p>
                                        </div>

                                        <div class="col-6 col-md-3 mb-3">
                                            <label>Estoque reservado</label>
                                            <p>
                                                {{gridRow.stores[0].reservedStockQty | infoOrPlaceholder}}

                                                <a :href="urlToReservedStockOrder(gridRow)" 
                                                    target="_blank"    
                                                    v-show="!!gridRow.stores[0].reservedStockQty | infoOrPlaceholder"
                                                    class="text-muted">
                                                    <fa icon="external-link-alt" class="ml-3" />
                                                </a>
                                            </p>
                                        </div>        

                                        <div class="col-6 col-md-3 mb-3">
                                            <label>Estoque disponível</label>
                                            <p>{{gridRow.stores[0].totalAvailableStockQty()}}</p>
                                        </div>       

                                        <div class="col-6 col-md-3 mb-3">
                                            <label>Fator de conversão</label>
                                            <p>{{gridRow.stockConversionRatio | infoOrPlaceholder}}</p>
                                        </div>       
                                    </div>
                                </div>

                                <div class="row" v-show="!!gridRow.uniqueChannels.length">
                                    <div class="col-12 col-md-2">
                                        <label>Canal</label>
                                    </div>
                                    <div class="col-12 col-md-2">
                                        <div class="label-with-tooltip">
                                            <label>Loja</label>
                                            <div class="info-icon-wrapper">
                                                <fa icon="question-circle" class="info-icon" />
                                                <div class="info-tooltip">
                                                    <strong>De onde vem esse vínculo?</strong>
                                                    <p>
                                                        A relação entre uma variação e sua loja <strong>não é configurada no Muven</strong>.
                                                        Ela é definida na sua <em>retaguarda (ERP)</em>, que envia essa informação ao Muven via integração.
                                                    </p>
                                                    <p>
                                                        Isso é diferente da configuração de <em>lojas responsáveis pelo estoque</em>
                                                        feita nas configurações do canal, que determina de qual loja o estoque será enviado a canal.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-3">
                                        <label>Preços (Listagem / Venda)</label>
                                    </div>
                                    <div class="col-12 col-md-2">
                                        <label>Estoque no canal</label>
                                    </div>
                                    <div class="col-12 col-md-3">
                                        <label>Id no canal</label>
                                    </div>
                                </div>

                                <div class="row" v-for="(storeChannel, index) in gridRow.uniqueChannels" :key="index">
                                    <div class="col-12 col-md-2 mb-3">
                                        <p>{{storeChannel.channel.name}}</p>
                                    </div>
                                    <div class="col-12 col-md-2 mb-3">
                                        <p>{{storeChannel.storeName | infoOrPlaceholder}}</p>
                                    </div>
                                    <div class="col-12 col-md-3 mb-3">
                                        <!-- <p>{{storeChannel.calculatedListPrice | currency}} / {{storeChannel.calculatedSellPrice | currency}}</p> -->
                                        <p>{{storeChannel.listPrice | currency}} / {{storeChannel.sellPrice | currency}}</p>
                                    </div>
                                    <div class="col-12 col-md-2 mb-3">
                                        <p>{{storeChannel.calculatedStockQty | infoOrPlaceholder}}</p>
                                    </div>
                                    <div class="col-12 col-md-3 mb-3">
                                        <p>{{storeChannel.idExternalChannel | infoOrPlaceholder}}</p>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-6 col-md-3 mb-3">
                                        <label>Peso</label>
                                        <p>{{gridRow.weight | infoOrPlaceholder}} kg</p>
                                    </div>                

                                    <div class="col-6 col-md-3 mb-3">
                                        <label>Altura</label>
                                        <p>{{gridRow.height | infoOrPlaceholder}} cm</p>
                                    </div>                

                                    <div class="col-6 col-md-3 mb-3">
                                        <label>Largura</label>
                                        <p>{{gridRow.width | infoOrPlaceholder}} cm</p>
                                    </div>               

                                    <div class="col-6 col-md-3 mb-3">
                                        <label>Profundidade</label>
                                        <p>{{gridRow.depth | infoOrPlaceholder}} cm</p>
                                    </div>                
                                </div>

                                <div class="row">
                                    <div class="col-6 col-md-3 mb-3">
                                        <label>Código EAN</label>
                                        <p>{{gridRow.eanCode | infoOrPlaceholder}}</p>
                                    </div>

                                    <div class="col-6 col-md-3 mb-3">
                                        <label>Código NCM</label>
                                        <p>{{gridRow.ncmCode | infoOrPlaceholder}}</p>
                                    </div>

                                    <div class="col-6 col-md-3 mb-3" v-if="!!gridRow.stores.length === 1">
                                        <label>Atualização por loja</label>
                                        <p v-if="!!gridRow.stores.length">{{gridRow.stores[0].updatedAt | dateTimeFilter}}</p>
                                        <p v-if="!gridRow.stores.length">-</p>
                                    </div>

                                    <div class="col-6 col-md-3 mb-3">
                                        <label>Auditoria</label>
                                        <p>Visualizar
                                            <a class="text-muted mt-2" 
                                                :href="getAuditUrl(gridRow.id, EntityEnum.Product)" target="_blank">
                                                <fa icon="external-link-alt" class="muven-external-link ml-1" />
                                            </a>
                                        </p>
                                    </div>
                                    <div class="col-6 col-md-3 mb-3">
                                        <label>Pedidos</label>
                                        <p>Visualizar
                                            <a class="text-muted mt-2" 
                                                :href="urlToOrder(gridRow)" target="_blank">
                                                <fa icon="external-link-alt" class="muven-external-link ml-1" />
                                            </a>
                                        </p>
                                    </div>
                                </div>

                                <div class="row mb-3">
                                    <div class="col">
                                        <label>Imagens</label>
                                        <span v-if="!gridRow.images.length">-</span>
                                        <span v-if="!!gridRow.images.length">
                                            <div class="product-variation-images-container d-flex flex-row">
                                                <div v-for="(image, index) in gridRow.images" :key="index"
                                                    :class="{'ml-3': index > 0}">
                                                    <img :src="image.url" 
                                                        @click="viewProductImage($event)"
                                                        alt="Imagem">

                                                    <p class="product-image-dimensions">
                                                        <span>{{image.getSizeInformation()}}</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </span>
                                    </div>
                                </div>

                                <div class="variation-store-container"
                                    v-show="gridRow.stores.length > 1">                
                                    <div class="row mb-3">
                                        <div class="col-6">
                                            <label>Estoque somado</label>
                                            <p>{{gridRow.stockQty}}</p>
                                        </div>

                                        <div class="col-6">
                                            <label>Fator de conversão</label>
                                            <p>{{gridRow.stockConversionRatio | infoOrPlaceholder}}</p>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-12 mb-3">
                                            <label>Loja</label>
                                            <multiselect
                                                v-model="gridRow.chosenStore"
                                                :options="gridRow.storeOptions"
                                                :multiple="false"
                                                :show-labels="false"
                                                :allow-empty="false"
                                                label="name"
                                                track-by="id"
                                                @select="selectProductStore"
                                                placeholder="" />
                                            <small v-show="!!gridRow.chosenProductStore.updatedAt" class="text-muted">Última atualização em {{gridRow.chosenProductStore.updatedAt | dateTimeFilter | infoOrPlaceholder}}</small>
                                        </div>
                                    </div>

                                    <div class="row" v-show="gridRow.chosenProductStore.blockStock">
                                        <div class="col-12">
                                            <div class="muven-tip tip-danger mb-3">
                                                <fa icon="info" class="tip-icon" />
                                                <p>Esta variação tem o estoque bloqueado na loja {{gridRow.chosenStore.name}}.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-6 col-md-3 mb-3">
                                            <label>Preço de listagem</label>
                                            <p>{{gridRow.chosenProductStore.listPrice | currency}}</p>
                                        </div>

                                        <div class="col-6 col-md-3 mb-3">
                                            <label>Preço de venda</label>
                                            <p>{{gridRow.chosenProductStore.sellPrice | currency}}</p>
                                        </div>

                                        <div class="col-6 col-md-3 mb-3">
                                            <label>Preço de custo</label>
                                            <p>{{gridRow.chosenProductStore.costPrice | currency}}</p>
                                        </div>
                                    </div>

                                    <div class="row" v-show="!gridRow.chosenProductStore.blockStock">
                                        <div class="col-6 col-md-3">
                                            <label>Estoque</label>
                                            <p>{{gridRow.chosenProductStore.stockQty}}</p>
                                        </div>

                                        <div class="col-6 col-md-3">
                                            <label>Estoque reservado</label>
                                            <p>
                                                {{gridRow.chosenProductStore.reservedStockQty}}

                                                <a :href="urlToReservedStockOrder(gridRow)" 
                                                    target="_blank"    
                                                    v-show="!!gridRow.chosenProductStore.reservedStockQty"
                                                    class="text-muted">
                                                    <fa icon="external-link-alt" class="ml-3" />
                                                </a>
                                            </p>
                                        </div>        

                                        <div class="col-6 col-md-3">
                                            <label>Estoque disponível</label>
                                            <p>{{gridRow.chosenProductStore.totalAvailableStockQty()}}</p>
                                        </div>       
                                    </div>

                                    <div class="row" v-show="gridRow.chosenProductStore.blockStock">
                                        <div class="col-12">
                                            <label>Estoque</label>
                                            <p class="mb-0">Bloqueado</p>
                                        </div>      
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="product-variation-count">
                            <span class="text-muted">{{productVariations.length}} {{productVariations.length === 1 ? 'variação' : 'variações'}}</span>
                            <span class="count-separator">·</span>
                            <span class="text-muted">{{totalStockQty}} em estoque</span>
                            <div class="info-icon-wrapper">
                                <fa icon="question-circle" class="info-icon" />
                                <div class="info-tooltip info-tooltip-left">
                                    <strong>Como esse total é calculado?</strong>
                                    <p>
                                        É a soma do campo <em>Estoque Somado</em> de cada variação, ou seja,
                                        o estoque consolidado entre todas as lojas daquela variação.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { ProductModel } from '@/product/models/ProductModel'
import { dateTimeFilter } from '@/utils/filters/DateTimeFilter'
import { infoOrPlaceholder } from '@/utils/filters/InformationOrPlaceholderFilter'
import { EntityEnum, OrderStatusEnum } from '@c2b/muven-commons'
import GetAuditUrl from '../../utils/mixins/GetAuditUrl'
import { StoreModel } from '@/store/models/StoreModel'
import { ProductStoreModel } from '../models/ProductStoreModel'

export default {
    name: 'ProductWithVariationsCmp',    
    props: {
        product: {
            required: true,
            type: ProductModel,
            default: new ProductModel(),
        },
    },
    data() {
       return {
            EntityEnum,
            productImageUrl: '',
            productImageBeingViewed: '',
            productVariations: this.product.toBidimensionalGrid().getGrid().map((gridRow) => {
                let storeOptions = []

                if (gridRow.stores.length) {
                    storeOptions = StoreModel.getStoreListWithIdAndName(gridRow.stores.map((ps) => {
                        return {
                            ...ps.store,
                            // Sets the idVariation in every store because it'll be needed
                            // to check which variation is supposed to have the productStore updated
                            // based on the store. This is ugly, but I blame on the multiselect component.                            
                            idVariation: gridRow.id,
                        }
                    }))
                }

                return {
                    ...gridRow,
                    storeOptions,
                    chosenStore: gridRow.stores.length ? storeOptions[0] : new StoreModel(),
                    chosenProductStore: gridRow.stores.length ? gridRow.stores[0] : new ProductStoreModel(),
                }
            }),
            breadcrumbList: [
                {
                    id: 0,
                    description: 'Produtos',
                    path: '/produtos',
                },
                {
                    id: 1,
                    description: `Detalhes de #${this.$route.params.id}`,
                    path: '',
                },
            ],
       } 
    },
    filters: {
        dateTimeFilter,        
        infoOrPlaceholder,
    },
    mixins: [
        GetAuditUrl,
    ],
    methods: {
        toggleVariationCollapse(v) {
            v.collapsed = !v.collapsed
        },
        viewProductImage(ev) {
            this.productImageUrl = ev.target.currentSrc
            this.productImageBeingViewed = true
        },
        closeProductImageVisualization() {
            this.productImageBeingViewed = false
        },
        selectProductStore(store) {
            for (const v of this.productVariations) {
                if (v.id === store.idVariation) {
                    v.chosenProductStore = v.stores.find((s) => {
                        return String(s.idStore) === String(store.id) && v.id === store.idVariation
                    }) || new ProductStoreModel()
                }
            }
        },
    },
    computed: {
        ...mapState({
            subscriber: state => state.subscriber,
        }),
        bidimensionalGrid() {
            return this.product.toBidimensionalGrid()
        },
        urlToReservedStockOrder() {
            return (v) => {
                return `/pedidos?custom=true&productIdList=${v.id}&statusList=${OrderStatusEnum.Pending}`
            }
        },
        urlToOrder() {
            return (v) => {
                return `/pedidos?custom=true&productIdList=${v.id}`
            }
        },
        totalStockQty() {
            return this.productVariations.reduce((acc, v) => acc + (v.stockQty || 0), 0)
        },
    },
}
</script>

<style lang="scss" scoped>
.label-with-tooltip {
    display: flex;
    align-items: center;
    gap: 4px;

    label {
        margin-bottom: 0;
    }
}

.info-icon-wrapper {
    position: relative;
    display: inline-flex;

    .info-icon {
        color: var(--text-disabled);
        font-size: 13px;
        cursor: pointer;

        &:hover {
            color: var(--text-muted);
        }
    }

    .info-tooltip {
        display: none;
        position: absolute;
        left: 22px;
        top: -8px;
        width: 280px;
        background: var(--surface-tooltip);
        color: var(--text-on-tooltip-soft);
        font-size: 12px;
        line-height: 1.5;
        padding: 10px 12px;
        border-radius: 6px;
        box-shadow: 0 4px 16px color-mix(in srgb, var(--shadow-ink) 20%, transparent);
        z-index: 200;

        p {
            margin: 6px 0 0 0;
        }

        strong {
            color: var(--text-on-brand);
        }

        em {
            color: var(--danger-on-dark);
            font-style: normal;
            font-weight: 600;
        }
    }

    .info-tooltip-left {
        left: auto;
        right: 22px;
        top: auto;
        bottom: 22px;
    }

    &:hover .info-tooltip {
        display: block;
    }
}

.muven-product-big-image-visualization {
    .muven-product-big-image-backdrop {
        position: fixed;
        background-color: var(--surface-tooltip);
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 998;
        opacity: .6;
    }

    .muven-product-big-image-container {
        position: fixed;
        top: 10vh;
        left: 0;
        z-index: 999;

        img {
            border-radius: 0;
            width: 100%;
        }

        .muven-product-big-image-close-icon {
            cursor: pointer;
            position: fixed;
            color: var(--text-on-tooltip);
            font-size: 2em;
            top: calc(10vh - 55px);
            right: 15px;
        }

        @media(min-width: 768px) {
            left: 50%;
            transform: translateX(-50%);

            img {
                border-radius: 2px;
                max-width: 80vh;
            }

            .muven-product-big-image-close-icon {
                top: -55px;
                right: auto;
            }
        }
    }
}

.muven-card {
    overflow: hidden;

    &.store-info-card {
        overflow: unset;
    }

    .main-product-info-container {
        height: 378px;
        overflow: auto;
    }

    .product-variation-list-card {
        margin: -15px;

        .product-variation-item {            
            padding: 15px;
            font-size: .9em;
            border-bottom: 1px solid var(--border-subtle);

            &:nth-of-type(even) {
                background-color: color-mix(in srgb, var(--text-strong) 2.5%, transparent);
            } 

            &:last-of-type {
                border-bottom-color: transparent;
            }

            .product-variation-main-info {
                position: relative;
                margin-bottom: -15px;

                .variation-visibility-toggle-container {
                    width: 40px;
                    height: 40px;
                    padding: 8px;
                    cursor: pointer;
                    position: absolute;
                    top: 8px;
                    right: 8px;

                    .variation-toggle-icon {
                        color: var(--text-muted);
                        font-size: 1.25em;
                        transition: transform .3s ease;

                        &.variation-toggle-icon-flipped {
                            transform: rotate(180deg);
                        }
                    }
                }
            }

            .product-variation-more-info {
                display: none;
                margin-top: 15px;

                &.variation-visible {
                    display: block;
                }

                .variation-store-container {
                    padding: 15px;
                    margin: 0;
                    border: 1px solid var(--border);
                    border-bottom: none;
                    position: relative;
                    background-color: var(--surface-1);

                    &:first-of-type {
                        border-top-left-radius: 4px;
                        border-top-right-radius: 4px;
                    }

                    &:last-of-type {
                        border-bottom-left-radius: 4px;
                        border-bottom-right-radius: 4px;
                        border-bottom: 1px solid var(--border);
                        margin-bottom: 15px;
                    }

                    .variation-store-name {
                        position: absolute;
                        top: 8px;
                        left: 15px;
                        font-weight: 600;
                        text-transform: uppercase;
                        letter-spacing: 1px;                        
                    }
                }

                .product-variation-images-container {
                    margin-top: 15px;

                    img {
                        height: 75px;
                        margin-right: 6px;
                        cursor: pointer;
                        transition: transform .1 ease; 

                        &:last-of-type {
                            margin-right: 0;
                        }

                        &:hover {
                            transform: scale(1.3);
                        }
                    }

                    .product-image-dimensions {
                        font-size: .8em;
                        margin: 15px 0 0 0;
                        text-align: center;
                        color: var(--text-muted);   
                    }
                }
            }
        }
    }

    .product-variation-count {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 8px;
        padding: 10px 15px;
        border-top: 1px solid var(--border-subtle);
        font-size: .85em;

        .count-separator {
            color: var(--text-disabled);
        }
    }

    .product-image-container {
        img {
            display: block;
            width: 150px;
            height: 150px;
            margin: 0 auto 10px auto;
        }

        .product-image-dimensions {
            margin: -10px 0 10px 0;
            color: var(--text-muted);
        }

        .product-image-description {
            &.image-main,
            &.image-inactive {
                border: 1px solid var(--border);
                padding: 0;
                max-width: 70px;
                border-radius: 2px;
                margin: 0 auto;
                font-size: .85em;
                letter-spacing: 1px;
                margin-bottom: 15px;
            }

            &.image-main {
                border-color: var(--brand-soft);
                color: var(--brand);
                background-color: var(--tint-brand-hover);
            }

            &.image-inactive {
                background-color: var(--surface-3);
                color: var(--text-muted);
            }
        }

        @media(min-width: 992px) {
            img {
                cursor: pointer;
                display: inline-block;
                width: 200px;
                height: 175px;
                margin-top: 15px;
                margin-right: 15px;           
                margin-bottom: 15px;

                &:last-of-type {
                    margin-right: 0;
                }
            }
        }
    }
}
</style>

